import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const RulesIndicator = ({ rulesCount }: { rulesCount: number }) => {
	const { formatMessage } = useIntl();
	if (rulesCount <= 0) return null;

	return (
		<Text>
			{formatMessage(messages.hasRulesIndicator, {
				rulesCount,
			})}
		</Text>
	);
};

export default RulesIndicator;
